module.exports = __webpack_public_path__ + "static/media/sona.f8788a23.png";